export default __webpack_public_path__ + "static/media/nectarine.80dd07be.jpg";